export default {
  searchQueryMaxLength: 150,
  textResultsPerPage: 5,
  videoResultsPerPage: 4,
  videoTabResultsPerPage: 200,
  welcomeContentTag: 'region_welcome',
  productRegistrationExpiration: 43200, // minutes
  productInformation: {
    searchBySN: 'sn',
    warranty: true,
    price:true,
  },
  products: {
    filterByAgent: 'agent',
  },
  region_repairtab: 'region_repairtab',
};
